import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)
export default function dateLocal(value) {
  return dayjs(value).format('L')
}
